import _ from 'lodash';
import sigils from '../constants/sigils';

const makeTldList = function({products, currency}) {
  const sigil = sigils[currency];

  const mapTldOptions = function(options, tld) {
    const value = products.domain[tld].P1Y.prices[currency];
    const formattedTld = {
      'tld': tld,
      'value': value,
      'formattedValue': `${sigil}${value}`,
    };

    return formattedTld;
  };

  return _.map(products.domain, mapTldOptions);
};

export default makeTldList;
